import { useMetadataHistoryStore } from "./metadata-history-store";
import { useMetadataEditingStore } from "./metadata-editing-store";
import { create } from "zustand";
import { saveSchedule } from "../lib/schedule-document/schedule-storage";
import type { ProjectedSchedule } from "../lib/schedule-history/project-schedule";
import { initialFold, toProjection } from "../lib/schedule-history/project-schedule";
import type { ArtMetadata } from "../lib/schedule-presets/art-metadata";

export { emptySlot } from "../lib/schedule-document/schedule-values";
export type { StreamSlot } from "../lib/schedule-document/schedule-values";

type ScheduleState = ProjectedSchedule & {
  storageFailed: boolean;
  anchorsVisible: boolean;
  developerMode: boolean;
  canvasMetadata: ArtMetadata | null;
  setDeveloperMode: (enabled: boolean) => void;
  toggleAnchors: () => void;
};

export const useScheduleStore = create<ScheduleState>((set) => ({
  ...toProjection(initialFold).schedule,
  storageFailed: false,
  anchorsVisible: true,
  developerMode: false,
  canvasMetadata: null,
  setDeveloperMode: (developerMode) => set({ developerMode }),
  toggleAnchors: () => set((state) => ({ anchorsVisible: !state.anchorsVisible })),
}));

useScheduleStore.subscribe((state, previous) => {
  if (
    state.offlineMessages === previous.offlineMessages &&
    state.offlineActive === previous.offlineActive &&
    state.slots === previous.slots &&
    state.commonOptions === previous.commonOptions &&
    state.selectedDate === previous.selectedDate &&
    state.timezone === previous.timezone
  )
    return;
  const storageFailed = !saveSchedule(state);
  if (state.storageFailed !== storageFailed) useScheduleStore.setState({ storageFailed });
});

useMetadataHistoryStore.subscribe(state => {
  const projection = state.sessions[state.activeId]?.projection ?? null;
  if (useScheduleStore.getState().canvasMetadata !== projection) useScheduleStore.setState({ canvasMetadata: projection });
});
useScheduleStore.subscribe((state, previous) => {
  if (state.preset.id === previous.preset.id) return;
  useMetadataEditingStore.getState().select(null);
  useMetadataHistoryStore.getState().activate(state.preset.id, state.preset.metadata);
});
const initialPreset = useScheduleStore.getState().preset;
useMetadataHistoryStore.getState().activate(initialPreset.id, initialPreset.metadata);
